import React from 'react';
import { change } from 'redux-form';

import tr from '../lib/tr';
import styles from './GaugeOld.scss';

class Gauge extends React.Component {
  constructor(props) {
    super(props);
    this.ref = [React.createRef(), React.createRef()];
  }

  componentDidMount() {
    this.updateValues();
  }

  componentDidUpdate() {
    this.updateValues();
  }

  tr(en, ja) {
    return tr(en, ja, this.props.lang);
  }

  updateValues() {
    const { value } = this.props.input;
    this.ref[0].current.value = value[0];
    this.ref[1].current.value = value[1];
  }


  input(ref, name, min, max, disabled, onChange) {
    return (
      <input ref={ref}
        name={name}
        type="number"
        min={min}
        max={max}
        placeholder="year"
        disabled={disabled}
        required
        onChange={onChange}
        className={styles.input}
      />
    );
  }

  gaugeBoxStyle(_start, _end) {
    const { min: _min, max: _max } = this.props;
    const [min, max] = [Number(_min), Number(_max) + 1];
    const [start, end] = [Number(_start), Number(_end) + 1];

    const diff = max - min;
    return {
      width: `${(end - start) / diff * 100}%`,
      marginLeft: `${(start - min) / diff * 100}%`,
    };
  }

  gauge() {
    const { input, meta, min, max, placeholder, disabled } = this.props;
    const names = ['min', 'max'].map(e => `${input.name}_${e}`);

    const onChange = (event) => {
      const newValue = [...input.value];
      names.forEach((name, idx) => {
        if (event.target.name === name) {
          newValue[idx] = event.target.value;
        }
      });

      input.onChange(newValue);
      // if (String(newValue[0]).length !== String(newValue[1]).length || Number(newValue[0]) <= Number(newValue[1])) {
      //   input.onChange(newValue);
      // } else {
      //   input.onChange(input.value);
      // }
      // this.forceUpdate();
    };

    return (
      <div>
        {this.tr('from', '')}{this.input(this.ref[0], names[0], min, max, disabled, onChange)}
        {this.tr('to', '～')}{this.input(this.ref[1], names[1], min, max, disabled, onChange)}
        <div className={styles.spanGauge}>
          {min}
          <div className={styles.gaugeBox}>
            <div className={styles.gaugeBar} style={this.gaugeBoxStyle(...input.value)}></div>
          </div>
          {max}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.gauge()}
      </div>
    );
  }
}

export default Gauge;
